import { b as r } from "./export-cdcbfb2b.js";
var u = r, i = u(1 .valueOf);
export {
  i as t
};
